import React, { SVGProps } from 'react';

/* eslint-disable max-len */
const SvgEngooTutorLogo: React.FunctionComponent<
  SVGProps<SVGSVGElement>
> = props => (
  <svg
    viewBox="0 0 749 112"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <defs>
      <path
        d="M499.91 67h-9.08V31.73H479.2v-7.56h32.34v7.56h-11.63V67zm70.46-42.83v27.71c0 3.17-.71 5.94-2.13 8.32-1.41 2.39-3.46 4.21-6.14 5.48-2.67 1.27-5.83 1.9-9.49 1.9-5.5 0-9.78-1.4-12.83-4.23-3.05-2.82-4.57-6.68-4.57-11.58v-27.6h9.05v26.22c0 3.3.67 5.72 2 7.26 1.32 1.55 3.52 2.32 6.59 2.32 2.97 0 5.12-.78 6.46-2.33 1.33-1.55 2-3.99 2-7.31V24.17h9.06zM614.75 67h-9.09V31.73h-11.63v-7.56h32.35v7.56h-11.63V67zM688 45.53c0 7.09-1.76 12.53-5.27 16.34-3.52 3.81-8.56 5.72-15.12 5.72-6.56 0-11.6-1.9-15.12-5.72-3.51-3.8-5.27-9.27-5.27-16.4 0-7.13 1.76-12.58 5.29-16.34 3.52-3.76 8.58-5.64 15.16-5.64s11.61 1.9 15.1 5.69c3.49 3.79 5.23 9.24 5.23 16.35zm-31.26 0c0 4.78.9 8.38 2.73 10.8 1.81 2.43 4.53 3.64 8.14 3.64 7.25 0 10.87-4.82 10.87-14.44 0-9.65-3.6-14.48-10.81-14.48-3.62 0-6.34 1.22-8.18 3.65-1.83 2.43-2.75 6.04-2.75 10.83zm66.59-2.35h2.93c2.87 0 4.99-.48 6.35-1.43 1.37-.96 2.05-2.46 2.05-4.52 0-2.03-.7-3.47-2.1-4.33-1.39-.86-3.55-1.3-6.48-1.3h-2.75v11.58zm0 7.38V67h-9.09V24.17h12.48c5.82 0 10.13 1.06 12.92 3.18 2.8 2.12 4.2 5.33 4.2 9.65 0 2.52-.7 4.76-2.09 6.72-1.38 1.97-3.35 3.5-5.89 4.62 6.45 9.63 10.65 15.85 12.6 18.66H738.4l-10.22-16.44h-4.83z"
        id="id1581185491__a"
      />
    </defs>
    <g fill="none" fillRule="nonzero">
      <use fill="#FFF" xlinkHref="#id1581185491__a" />
      <use fill="#B8B8B8" xlinkHref="#id1581185491__a" />
      <g>
        <path
          d="M167.53 38.02h.02c-.15-20.46-16.75-37-37.22-37-20.46 0-37.06 16.54-37.22 37v44.57c0 4.95 4.12 8.97 9.07 8.97 4.8 0 8.61-3.64 8.83-8.39V37.84c.61-10.16 9.02-18.22 19.32-18.22 10.36 0 18.82 8.15 19.34 18.4v44.92h.04a8.95 8.95 0 0 0 8.94 8.62c4.94 0 8.9-4.02 8.9-8.97l-.02-44.57"
          fill="#404040"
        />
        <path
          d="M330.61 38.2a5.51 5.51 0 1 1-11.03 0 5.51 5.51 0 0 1 11.03 0"
          fill="#459AF8"
        />
        <path
          d="M408.18 38.2a5.52 5.52 0 1 1-11.03 0 5.52 5.52 0 0 1 11.03 0"
          fill="#EB4A57"
        />
        <path
          d="M316.67 73.6c-10.02 0-18.23-7.63-19.18-17.4h.02l-.02-18.7c.61-10.12 8.92-18.13 19.18-18.13 10.32 0 18.75 8.1 19.26 18.3h.01V55.3c-.52 10.2-8.95 18.3-19.27 18.3zm43.65-12.98l-6.59-16.7v-6.25h.03c-.16-20.35-16.7-36.8-37.1-36.8-20.38 0-36.92 16.45-37.08 36.8V55.3c.16 20.36 16.7 36.8 37.09 36.8 17.58 0 32.28-12.22 36.11-28.63h4.87c3.74 0 2.67-2.85 2.67-2.85z"
          fill="#3B9CFF"
        />
        <path
          d="M410.06 73.6c-10.01 0-18.3-7.63-19.24-17.4l.09-18.7c.6-10.12 8.9-18.13 19.15-18.13 10.33 0 18.75 8.1 19.27 18.3V55.3c-.52 10.2-8.94 18.3-19.26 18.3zm37.1-35.93C447 17.32 430.45.87 410.05.87c-20.38 0-36.93 16.45-37.08 36.8l.14 5.77-6.79 17.18s-1.06 2.85 2.67 2.85h4.95c3.83 16.4 18.54 28.64 36.12 28.64 20.08 0 36.46-15.98 37.08-35.91V37.67z"
          fill="#F64C58"
        />
        <path
          d="M17.96 37.31C18.66 27.3 27 19.37 37.2 19.37c10.2 0 18.54 7.92 19.23 17.94H17.96zm56.3-.35C73.72 16.94 57.34.86 37.19.86S.66 16.95.13 36.97l.01 19.57C.95 76.3 17.21 92.1 37.2 92.1c9.34 0 17.87-3.46 24.39-9.16 2.29-1.94 4.49-4.55 4.49-7.92a9.25 9.25 0 0 0-9.25-9.25c-2.52 0-4.8 1-6.46 2.64a19.21 19.21 0 0 1-13.17 5.19c-10.32 0-18.75-8.39-19.26-18.58h48.2c4.34-.53 7.8-4.06 8.13-8.46v-9.61zM223.28 55.96c-10.32 0-18.75-8.1-19.27-18.3.52-10.19 8.95-18.29 19.27-18.29s18.75 8.1 19.26 18.3c-.51 10.19-8.94 18.3-19.26 18.3zm37.09-18.3c-.17-20.34-16.7-36.8-37.1-36.8-20.38 0-36.92 16.46-37.08 36.81.16 20.35 16.7 36.8 37.09 36.8a36.9 36.9 0 0 0 19.27-5.4v5.98c-.52 10.2-8.95 18.3-19.27 18.3-5.07 0-10.51-2.79-13.19-5.1-1.97-1.71-4.22-3.26-7.03-3.26a9.25 9.25 0 0 0-9.26 9.25c0 3.36 1.97 6.04 4.47 7.91 7.16 5.35 15.37 9.7 25 9.7 20.4 0 36.94-16.44 37.1-36.8h-.03l.03-37.39z"
          fill="#404040"
        />
      </g>
    </g>
  </svg>
);
/* eslint-enable max-len */

export default SvgEngooTutorLogo;
